import './Notification.css';

import React, { useState, useEffect } from 'react';
import useB2BTranslation from './hooks/useB2BTranslation';
import { CheckCircle, Error, Info, Warning } from '@mui/icons-material';

export const showNotification = (setNotification, message, type, duration = 3000) => {
    const uniqueKey = new Date().getTime();
    setNotification({ message, type, duration, key: uniqueKey });
};

export const showErrorNotification = (setNotification, message, error, duration = 5000) => {
    const uniqueKey = new Date().getTime();
    const errorMessage = error?.response?.data?.message || error?.message || message || 'An error occurred';
    const errorText = `${errorMessage}`;
    setNotification({ message: errorText, type: 'error', duration, key: uniqueKey });
};

const getNotificationTypeIcon = (type) => {
    switch (type) {
        case 'success':
            return (
                <div className='notification-icon success'>
                    <CheckCircle />
                </div>
            );
        case 'error':
            return (
                <div className='notification-icon error'>
                    <Error />
                </div>
            );
        case 'warning':
            return (
                <div className='notification-icon warning'>
                    <Warning />
                </div>
            );
        case 'info':
            return (
                <div className='notification-icon info'>
                    <Info />
                </div>
            );
        default:
            return null;
    }
};

const Notification = ({ notification = {} }) => {
    const { t } = useB2BTranslation('b2b-common');
    const { message, type, duration, key } = notification ? notification : {};
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (duration) {
            setVisible(true);
            const timer = setTimeout(() => {
                setVisible(false);
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [message, type, duration, key]);

    if (!visible) return null;

    return (
        visible && (
            <div className={`notification ${type}`}>
                {getNotificationTypeIcon(type)}
                <div
                    className='notification-message'
                    dangerouslySetInnerHTML={{ __html: message }}
                />
                <button onClick={() => { setVisible(false); }}>{t('Dismiss')}</button>
            </div>
        )
    );
};

export default Notification;